"use strict";
const { isQuoted, unQuotedString } = require('../../quotedSearchString');
const createSearchStringQuery = searchString => {
    if (!searchString) {
        return { or: [] };
    }
    const unQuotedSearchString = unQuotedString(searchString);
    if (isQuoted(searchString)) {
        const numberString = unQuotedSearchString.replace(/\D/g, '');
        const integerSearchString = (() => {
            const parsedInt = parseInt(numberString, 10);
            const sqlMaxInt = 2147483647;
            const sqlMinInt = -2147483648;
            return Number.isSafeInteger(parsedInt) &&
                parsedInt >= sqlMinInt &&
                parsedInt <= sqlMaxInt
                ? parsedInt
                : 0;
        })();
        return {
            or: [
                { customerNumber: unQuotedSearchString },
                { GLN: unQuotedSearchString },
                { organisationNumber: unQuotedSearchString },
                { qvantiId: integerSearchString },
            ],
        };
    }
    // Extract only numbers from searchString
    const numberString = unQuotedSearchString.replace(/\D/g, '');
    const integerSearchString = (() => {
        const parsedInt = parseInt(numberString, 10);
        const sqlMaxInt = 2147483647;
        const sqlMinInt = -2147483648;
        return Number.isSafeInteger(parsedInt) &&
            parsedInt >= sqlMinInt &&
            parsedInt <= sqlMaxInt
            ? parsedInt
            : 0;
    })();
    return {
        or: [
            { name: { iLike: `%${unQuotedSearchString}%` } },
            { deliveryName: { iLike: `%${unQuotedSearchString}%` } },
            { customerNumber: { iLike: `%${unQuotedSearchString}%` } },
            { organisationNumber: { iLike: `%${unQuotedSearchString}%` } },
            { deliveryCity: { iLike: `%${unQuotedSearchString}%` } },
            { deliveryAddress: { iLike: `%${unQuotedSearchString}%` } },
            { emailInvoice: unQuotedSearchString },
            { qvantiId: integerSearchString },
        ],
    };
};
module.exports = createSearchStringQuery;
